/* eslint-disable @typescript-eslint/no-non-null-assertion */
/* eslint-disable react-hooks/exhaustive-deps */
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import ArrowRightAltIcon from '@material-ui/icons/ArrowRightAlt';
import { makeStyles } from '@material-ui/styles';
import Button from 'components/Button';
import { Form, Formik } from 'formik';
import i18n from 'i18n';
import { forgotPasswordRequest } from 'modules/authenticate/actions';
import { ForgotPasswordRequestProps } from 'modules/authenticate/sagaInterfaces';
import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import GenericForm from 'skyone-lib/lib/GenericForm';
import ApplicationState from 'store/interfaces';
import useWindowDimensions from 'hooks/useWindowWidth';
import screenFields from './forgotPasswordFormFields';
import validationSchema from './schema';
import styles from './styles';

const useStyles = makeStyles(styles);

interface Props {
  forgotPasswordRequest: ({ payload }: ForgotPasswordRequestProps) => void;
  isLoading: boolean;
  language?: string;
}

const ForgotPasswordForm: React.FC<Props> = ({
  forgotPasswordRequest,
  isLoading,
}) => {
  const classes = useStyles();

  const onSubmit = values => {
    // eslint-disable-next-line no-undef
    grecaptcha
      .execute(process.env.REACT_APP_RECAPTCHA_PUBLIC_KEY_ADMIN_20!, {
        action: 'autosky_admin_operator_reset_password',
      })
      .then(token => {
        forgotPasswordRequest({ ...values, 'recaptcha_token': token });
      });
  };
  React.useEffect(() => {
    const script = document.createElement('script');

    script.src = 'https://www.recaptcha.net/recaptcha/api.js';
    script.async = true;
    script.defer = true;

    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  React.useEffect(() => {
    const script = document.createElement('script');

    script.src = `https://www.recaptcha.net/recaptcha/api.js?render=${process
      .env.REACT_APP_RECAPTCHA_PUBLIC_KEY_ADMIN_20!}`;
    script.async = true;
    script.defer = true;

    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  const { width } = useWindowDimensions();

  return (
    <Grid container item xs={12} alignContent="flex-start">
      {width > 960 && (
        <Grid item container xs={12} className={classes.spacingContainer}>
          <Grid item xs={12} className={classes.title}>
            <Typography variant="h3" className={classes.text}>
              {i18n.t('RESET_PASSWORD_PAGE.TITLE_KEY')}
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <Typography variant="body1" className={classes.subtitle}>
              {i18n.t('RESET_PASSWORD_PAGE.SUBTITLE_KEY')}
            </Typography>
          </Grid>
        </Grid>
      )}
      <Formik
        initialValues={{ email: '' }}
        validationSchema={validationSchema}
        onSubmit={onSubmit}
      >
        {({ setFieldValue, errors, values }) => (
          <Form style={{ width: '100%' }}>
            <Grid container className={classes.gridForgot}>
              <Grid
                item
                container
                xs={12}
                spacing={2}
                className={classes.forgotPassGrid}
              >
                <GenericForm
                  values={values}
                  screenFields={screenFields}
                  setFieldValue={setFieldValue}
                  errors={errors}
                />
              </Grid>

              <Grid item xs={12} className={classes.spacingContainer}>
                <Button
                  fullWidth
                  size="large"
                  type="submit"
                  className={classes.loginButton}
                  id="submit-button"
                  isLoading={isLoading}
                  style={{ margin: '32px 0 12px' }}
                >
                  {i18n.t('RECOVER_KEY')}
                </Button>
                <div
                  className="g-recaptcha"
                  data-sitekey={
                    process.env.REACT_APP_RECAPTCHA_PUBLIC_KEY_ADMIN_20!
                  }
                  data-callback="onSubmit"
                  data-size="invisible"
                  data-badge="bottomright"
                ></div>
                <Typography
                  id="back-button"
                  variant="button"
                  component={Link}
                  to="/"
                  className={classes.link}
                >
                  <ArrowRightAltIcon className={classes.arrowIcon} />
                  {i18n.t('BACK_KEY')}
                </Typography>
              </Grid>
            </Grid>
          </Form>
        )}
      </Formik>
    </Grid>
  );
};

const mapStateToProps = ({
  authenticate: { isLoading },
}: ApplicationState) => ({
  isLoading,
});

export default connect(mapStateToProps, { forgotPasswordRequest })(
  ForgotPasswordForm
);
